import React, { useContext, useEffect, useState } from "react";
import { ACTIONS,USERTYPES } from "../../../../constants/Constants";
import { t } from "i18next";
import { Dropdown, IconButton, PrimaryButton, TextField } from "@fluentui/react";
import CustomCheckBox from "../HeaderFileChecks/CustomCheckBox";
import { getSubModalityListNumbers } from "../../../../service/FirmServices";
import DropDown from "../../../../components/SVGComponents/Tools/DropDown";
import { FormikProvider, FieldArray, getIn } from "formik";
import { getTimeZones } from "@vvo/tzdb";
import themeContext from "../../../../context/theme/ThemeContext";
import Select from "react-select";
import { getEnv } from '../../../../helpers/EnvHelper';

const TZ_ALIAS_MAP = {
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "US/Eastern": "America/New_York",
  "US/Central": "America/Chicago",
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "US/Arizona": "America/Phoenix",
  "US/Alaska": "America/Anchorage",
  "US/Hawaii": "Pacific/Honolulu",
  "GMT": "Etc/GMT",
  "UTC": "Etc/UTC",
  "Etc/UCT": "Etc/UTC",
  "Etc/Universal": "Etc/UTC",
  "Etc/Zulu": "Etc/UTC",
  "W-SU": "Europe/Moscow",
  "Eire": "Europe/Dublin",
  "Hongkong": "Asia/Hong_Kong",
  "ROC": "Asia/Taipei",
  "Egypt": "Africa/Cairo",
  "Turkey": "Europe/Istanbul"
};

const normalizeTZ = (tz) => {
  if (!tz) return "UTC";
  return TZ_ALIAS_MAP[tz] || tz;
};


const timeZoneOptions = [
  ...getTimeZones().map(tz => {
    const offset = tz.rawOffsetInMinutes / 60;

    return {
      value: tz.name,
      label: `${tz.name} (UTC${offset >= 0 ? "+" : ""}${offset})`
    };
  })
];



const choiceGroupStyles = {
  label: {
    display: "inline",
  },
  flexContainer: {
    columnGap: "1em",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};
const ConfigureSettings = (props) => {
  const { theme, themeName ,getThemeColor} = useContext(themeContext);
  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;
  
  const [enablePrintDisclaimerText, setEnablePrintDisclaimerText] = useState(
    props.values.addPrintDisclaimer
  );
  const [enableAddendumDisclaimerText, setEnableAddendumDisclaimerText] =
    useState(props.values.addendumDisclaimerEnabled);
  const [addendumWorkflowEnabled, setEnableAddendumWorkflow] = useState(
    props.values.addendumWorkflowEnabled
  );
const [showAiResultsSavedReportForFirmDoctors, setShowAiResultsSavedReportForFirmDoctors] = useState(
  props.values.showAiResultsSavedReportForFirmDoctors
);
  const [subModalityListNumbers, setSubModalityListNumbers] = useState([]);

  const [enableShareReportLink, setEnableShareReportLink] = useState(
  props.values.enableShareReportLink
);

  const bucketOptions = props.bucketList.slice(2).map(bucket => ({
    key: bucket.id,
    text: bucket.bucketName
  }));

    const effectiveTimeZone =
    props.values.firmTimeZone ||
    getEnv("REACT_APP_BACKEND_TIMEZONE") ||
    null;

   const mdl = [
      { key: "DX", text: "DX" },
      { key: "CT", text: "CT" },
      { key: "CR", text: "CR" },
      { key: "MR", text: "MR" },
      { key: "DEFAULT", text: "DEFAULT" },
    ];
    const [bucketModalityList, setBucketModalityList] = useState(mdl);
    const [userTimeZone, setUserTimeZone] = useState("__SYSTEM__");
  useEffect(()=>{
    if(props.action == "EDIT"){
      fetchSubModalityListNumbers();
    }
  },[props.action])

  const fetchSubModalityListNumbers = async () => {
    const response = await getSubModalityListNumbers();
    console.log(response)
    if (response.status === 200) {
      let mdl = [];
              response.data.data.map((listnum) => {
        mdl.push({
          key: listnum,
          text: listnum,
        });
      });
      setSubModalityListNumbers(mdl);
    }
  };

  return (
    <>
      <div className="tab-section">
        <section
          className="sectionA"
          style={{ marginBottom: props.action === ACTIONS.EDIT ? "" : "1rem" }}
        >
          <p
            style={{
              fontSize: "20px",
              fontWeight: "600",
              padding: "0px 0px",
              marginBottom: "20px",
            }}
          >
            {t("hospital.configure-settings")}
          </p>
        </section>
        {/* EDIT CONFIGURATION SETTINGS */}
        {props.action === ACTIONS.EDIT && props.firmType != 1 && (
          <>
            {/* ENABLE PRINT DISCLAIMER */}
            <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-print-disclaimer")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.addPrintDisclaimer}
                    onChangeCustom={() => {
                      setEnablePrintDisclaimerText(!enablePrintDisclaimerText);
                      props.values.addPrintDisclaimer =
                        !props.values.addPrintDisclaimer;
                    }}
                  />
                </div>
              </div>
            </div>
            {enablePrintDisclaimerText && (
              <div style={{ display: "flex", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.print-disclaimer-text")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value">
                  <div
                    style={{
                      marginTop: "5px",
                      marginLeft: "5px",
                    }}
                  >
                    <TextField
                      styles={{
                        root: {
                          width: "100%",
                        },
                      }}
                      name="printDisclaimerText"
                      placeholder={t("hospital.print-disclaimer-text")}
                      value={props.values.printDisclaimerText}
                      onBlur={props.handleBlur}
                      onChange={(e) => props.handleChange(e)}
                      multiline
                      autoAdjustHeight
                      errorMessage={
                        props.errorState?.configureSettings
                          ?.printDisclaimerText?.error &&
                        props.errorState?.configureSettings
                          ?.printDisclaimerText?.msg
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {/* ENTER ACCOUNT WARNING */}
            <div style={{ display: "flex", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.account-warning")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                  <TextField
                    name="accountWarning"
                    placeholder={t("hospital.account-warning")}
                    onChange={(e) => {
                      props.handleChange(e);
                    }}
                    value={props.values.accountWarning}
                    autoAdjustHeight
                    multiline
                    errorMessage={
                      props.errorState?.configureSettings?.accountWarning
                        ?.error &&
                      props.errorState?.configureSettings?.accountWarning?.msg
                    }
                  />
                </div>
              </div>
            </div>

            {/* MAX PRIORITY COUNT */}
            <div style={{ display: "flex", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.max-priority-count")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                  <TextField
                    name="priorityCount"
                    onChange={(e) => {
                      props.handleChange(e);
                      if (
                        props.errorState.priorityCount.error != undefined ||
                        props.errorState.priorityCount.error != null
                      ) {
                        props.errorState.priorityCount.error = false;
                      }
                    }}
                    errorMessage={
                      (props.errorState?.configureSettings?.priorityCount
                        ?.error &&
                        props.errorState?.configureSettings?.priorityCount
                          ?.msg) ||
                      props.firmGlobalErrorState?.priorityCount
                    }
                    value={props.values.priorityCount}
                    onBlur={props.handleBlur}
                    resizable={false}
                    type="number"
                  />
                </div>
              </div>
            </div>

             {/* SHOW PRIORS STUDIES */}
             <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-show-priors-studies")}
                </p>
              </div>
              <div id="show-priors-studies-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.showPriorsStudies}
                    onChangeCustom={() => {
                      props.values.showPriorsStudies =
                        !props.values.showPriorsStudies;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* ENABLE ADDENDUM WORKFLOW */}
            <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-addendum-workflow")}
                </p>
              </div>
              <div id="enable-addendum-workflow-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.addendumWorkflowEnabled}
                    onChangeCustom={() => {
                      setEnableAddendumWorkflow(!addendumWorkflowEnabled);
                      props.values.addendumWorkflowEnabled =
                        !props.values.addendumWorkflowEnabled;
                    }}
                  />
                </div>
              </div>
            </div>

             {/* Show AI Results and Saved Reports for Firm Doctors */}
            <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.show-ai-results-saved-report-firm-doctors")}
                </p>
              </div>
              <div id="show-ai-results-saved-report-firm-doctors-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.showAiResultsSavedReportForFirmDoctors}
                    onChangeCustom={() => {
                        setShowAiResultsSavedReportForFirmDoctors(!showAiResultsSavedReportForFirmDoctors);
                        props.values.showAiResultsSavedReportForFirmDoctors =
                          !props.values.showAiResultsSavedReportForFirmDoctors;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Split multi-frame DICOMs at upload */}
            <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "12px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.split-multiframe-dicoms")}
                </p>
              </div>
              <div id="multiframe-split-checkbox" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.multiframeSplit}
                    onChangeCustom={() => {
                      props.values.multiframeSplit =
                        !props.values.multiframeSplit;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* branch code */}
            {props.values.isMinimalAccount === 1 && (
                <>
                  <div style={{ display: "flex", minHeight: "40px", marginBottom: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.sub_modality_list_number")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <Dropdown
                          selectedKey={
                            props.values.selectedSubModalityListNumber
                          }
                          placeholder="Select Sub Modality List Number"
                          options={[...subModalityListNumbers]}
                          calloutProps={{ doNotLayer: true }}
                          onChange={(e, option) => {
                            props.values.selectedSubModalityListNumber =
                              option.key;
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", minHeight: "40px", marginBottom: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.branch-code")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                        <TextField
                          name="branchCode"
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          errorMessage={props.firmGlobalErrorState?.branchCode}
                          value={props.values.branchCode}
                          onBlur={props.handleBlur}
                          resizable={false}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}


              {/* ENABLE Send Report Submit Notification STUDY */}
                <>
                  <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-send-report-submit-notification")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.sendReportSubmitNotification}
                          onChangeCustom={() => {
                            props.values.sendReportSubmitNotification =
                              !props.values.sendReportSubmitNotification;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
                 {/* STUDY LINK EXPIRY TIME */}
              <div style={{ display: "flex", maxHeight: "60px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.study-link-validity-time")}
                  </p>
                </div>
                <div
                  className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div style={{ marginLeft: "5px", marginBottom: "10px" }}>
                    <TextField
                      type="number"
                      name="studyLinkExpiryTime"
                      placeholder={t("hospital.study-link-validity-time")}
                      value={props.values.studyLinkExpiryTime ?? ""}
                      onBlur={props.handleBlur}
                      onChange={props.handleChange}
                      errorMessage={
                        (props.errorState?.studyLinkExpiryTime?.error &&
                          props.errorState?.studyLinkExpiryTime?.msg) ||
                        props.firmGlobalErrorState?.studyLinkExpiryTime
                      }
                    />
                  </div>
                </div>
              </div>


                <div style={{ display: "flex", alignItems: "flex-start", minHeight: "40px", marginBottom: "12px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                    <p className="single-line-form-field-key">
                      {t("account-and-settings.timezone") || "Time Zone"}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div style={{ marginTop: "10px", marginLeft: "5px" }}>
                      <Select
                        classNamePrefix="react-select"
                        options={timeZoneOptions}
                        value={timeZoneOptions.find(
                          tz => tz.value === effectiveTimeZone
                        )}
                        isSearchable
                        onChange={(item) => {
                          props.setFieldValue("firmTimeZone", item?.value ?? null);
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            width: "100%",
                            color: getThemeColor("primary-color"),
                            backgroundColor: getThemeColor("action-details-background"),
                            border: getThemeColor("border"),
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor: getThemeColor("action-details-background"),
                          }),
                          option: (base, state) => ({
                            ...base,
                            color: getThemeColor("primary-color"),
                            backgroundColor: state.isFocused
                              ? getThemeColor("popup-hover")
                              : getThemeColor("action-details-background"),
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: getThemeColor("primary-color"),
                          }),
                          input: (base) => ({
                            ...base,
                            color: getThemeColor("primary-color"),
                          }),
                        }}
                      />
                      <p
                        style={{
                          fontSize: 13,
                          color: themeName === "light" ? "#808080" : "#bebebe",
                          marginTop: "6px",
                        }}
                      >
                        {t("account-and-settings.timezone-note-firm")}
                      </p>
                    </div>
                  </div>
                </div>
            
            {isBucketManagement && props.formik && (
              <fieldset className="border rounded p-4 fieldset-bucket-config">
                <legend className="font-bold">Bucket Configurations</legend>
                
                <FormikProvider value={props.formik}>
                <FieldArray name="modalityBuckets">
                  {({ push, remove }) => (
                    <div>
                      {(props.values.modalityBuckets || []).map((item, idx) => {
                        // Collect all selected modalities except the current one
                        const selectedModalities = props.values.modalityBuckets
                          .map((m, i) => (i !== idx ? m.modality : null))
                          .filter(Boolean);

                        // Filter available list for this dropdown
                        const availableModalities = bucketModalityList.filter(
                          option => !selectedModalities.includes(option.key)
                        );

                        return (
                          <div
                            key={idx}
                            style={{ display: "flex", marginBottom: 8, alignItems: "center" }}
                          >
                            <Dropdown
                              placeholder="Select Modality"
                              options={availableModalities}
                              selectedKey={item.modality}
                              onChange={(e, option) =>
                                props.setFieldValue(`modalityBuckets.${idx}.modality`, option.key)
                              }
                              style={{ width: 200, marginRight: 8 }}
                              errorMessage={getIn(
                                props.errors,
                                `modalityBuckets.${idx}.modality`
                              )}
                            />

                            <Dropdown
                              placeholder="Select Bucket"
                              options={bucketOptions}
                              selectedKey={item.bucketConfiguration}
                              onChange={(e, option) =>
                                props.setFieldValue(
                                  `modalityBuckets.${idx}.bucketConfiguration`,
                                  option.key
                                )
                              }
                              style={{ width: 200, marginRight: 8 }}
                            />

                            {item.modality !== "DEFAULT" && (
                              <IconButton
                                iconProps={{ iconName: "Delete" }}
                                onClick={() => remove(idx)}
                                disabled={props.values.modalityBuckets.length === 1}
                                title="Delete"
                                ariaLabel="Delete"
                                style={{ marginRight: 8 }}
                              />
                            )}

                            {props.values.modalityBuckets.length < bucketModalityList.length &&
                             idx === props.values.modalityBuckets.length - 1 && (
                              <PrimaryButton
                                iconProps={{ iconName: "Add" }}
                                text=""
                                ariaLabel="Add"
                                onClick={() =>
                                  push({ modality: "", bucketConfiguration: "" })
                                }
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </FieldArray>

              </FormikProvider>
               {typeof props.errorState?.configureSettings?.modalityBuckets?.msg === "string" && (
                <div style={{ color: "red", marginTop: "10px" }}>
                  {props.errorState?.configureSettings?.modalityBuckets?.msg}
                </div>
              )}
              </fieldset>
            )}

            {/* show MS Word
            { (
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-ms-word")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.showWord}
                      onChangeCustom={() => {
                        props.values.showWord = !props.values.showWord;
                      }}
                    />
                  </div>
                </div>
              </div>
            )} */}
          </>
        )}
        {/* VIEW CONFIGURATION SETTINGS */}
        {(props.action === ACTIONS.VIEW || props.firmType == 1) && (
          <>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-print-disclaimer")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.addPrintDisclaimer ? "Yes" : "No"}</div>
                </div>
              </div>
              {enablePrintDisclaimerText && (
                <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                    <div className="form-heading">Print Disclaimer</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                    <div>
                      {props.values.printDisclaimerText
                        ? props.values.printDisclaimerText
                        : "0"}
                    </div>
                  </div>
                </div>
              )}
              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.account-warning")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.accountWarning
                      ? props.values.accountWarning
                      : "-"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.max-priority-count")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.priorityCount
                      ? props.values.priorityCount
                      : "-"}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-show-priors-studies")}
                  </div>
                </div>
                <div id="show-priors-studies-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.showPriorsStudies ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-addendum-workflow")}
                  </div>
                </div>
                <div id="enable-addendum-workflow-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.addendumWorkflowEnabled ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.show-ai-results-saved-report-firm-doctors")}
                  </div>
                </div>
                <div id="show-ai-results-saved-report-firm-doctors-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.showAiResultsSavedReportForFirmDoctors ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.split-multiframe-dicoms")}
                  </div>
                </div>
                <div id="multiframe-split-value" className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.multiframeSplit ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-send-report-submit-notification-view")}
                  </div>
                </div>
                <div  className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.sendReportSubmitNotification ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.study-link-validity-time")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>
                    {props.values.studyLinkExpiryTime ? props.values.studyLinkExpiryTime : "0"}
                  </div>
                </div>
              </div>
              {props.values.isMinimalAccount === 1 && (
                  <>
                    <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.sub_modality_list_number")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                        <div>
                          {props.values.selectedSubModalityListNumber
                            ? props.values.selectedSubModalityListNumber
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.branch-code")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                        <div>
                          {props.values.branchCode
                            ? props.values.branchCode
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {props.firmType === 1 && (
                <>
                  <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <div className="form-heading">
                        {t("hospital.enable-addendum-disclaimer")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
                      <div>
                        {props.values.addendumDisclaimerEnabled ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                  {!!enableAddendumDisclaimerText && (
                    <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3">
                        <div className="form-heading">
                          {t("hospital.addendum-disclaimer-text")}
                        </div>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl8">
                        <div>
                          {props.values.addendumDisclaimerText
                            ? props.values.addendumDisclaimerText
                            : ""}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("account-and-settings.timezone") || "Time Zone"}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
                  <div>
                    {props.values.firmTimeZone
                      ? props.values.firmTimeZone
                      : getEnv("REACT_APP_BACKEND_TIMEZONE") || "-"}
                  </div>
                </div>
              </div>

              {isBucketManagement && (
              <fieldset className="border rounded p-4 fieldset-bucket-config">
                <legend className="font-bold">{t("Bucket Configuration")}</legend>

                {props.values.modalityBuckets && props.values.modalityBuckets.length > 0 ? (
                  props.values.modalityBuckets.map((item, idx) => (
                    <div key={idx} style={{ display: 'flex', marginBottom: 8, alignItems: 'center' }}>
                      <div style={{ width: 200, marginRight: 8 }}>
                        <label className="form-heading">{t("Modality")}</label>
                        <div style={{ paddingTop: 4 }}>
                          {bucketModalityList.find(o => o.key === item.modality)?.text || item.modality || "-"}
                        </div>
                      </div>
                      <div style={{ width: 200, marginRight: 8 }}>
                        <label className="form-heading">{t("Bucket Configuration")}</label>
                        <div style={{ paddingTop: 4 }}>
                          {bucketOptions.find(o => o.key === item.bucketConfiguration)?.text || item.bucketConfiguration || "-"}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>{t("No modality buckets assigned")}</div>
                )}
              </fieldset>
              )}
              {/* { (

              <div className="ms-Grid-row" style={{ minHeight: "40px", marginBottom: "12px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl3">
                  <div className="form-heading">
                    {t("hospital.enable-ms-word")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.showWord ? "Yes" : "No"}</div>
                </div>
              </div>
              )} */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigureSettings;